//@ts-ignore
import {SearchPlaceType} from "@customTypes/SearchPlaceTypes";
//@ts-ignore
import {PLACE_TYPE} from "@customTypes/PlaceType";
//@ts-ignore
import {Action} from "@customTypes/CustomUtilityTypes";
//@ts-ignore
import {useSearchBeanStore} from "@store/SearchBeanStore";


interface UsableSearchBeanPlace {
    updateSearchBeanBySearchPlace: (obj: SearchPlaceType, isValuationActive?: boolean) => void;
    updateSearchBeanByMapPlace: (mapPlace: { polygon: string; polygonForDB: string }) => void;
    updateCounter: Action;
}

export function useSearchBeanPlace(): UsableSearchBeanPlace{
    const searchBeanStore = useSearchBeanStore()

    const updateSearchBeanBySearchPlace = (obj: SearchPlaceType, isValuationActive = false): void => {
        /* We won't update the searchBean if we are in the valuation case */
        if (!obj.place || isValuationActive)
            return;

        searchBeanStore.updateSearchBean({
            areaOfInterestId: obj.place.areaOfInterestID,
            polygonFromMap: obj.polygon,
            polygonForDB: obj.polygonFromMap || obj.place.polygon,
            areaId: obj.place.areaID,
            placeId: obj.place.placeID,
            placeType: obj.place.placeType,
            localityIdList: /*obj.place.localityID ? [obj.place.localityID] : []*/ obj.searchBean?.localityIdList,
            zoneIdList: obj.place.placeType === PLACE_TYPE.DISTRICT ? [] : obj.searchBean?.zoneIdList,
            zoneId: obj.place.placeType === PLACE_TYPE.DISTRICT ? null : obj.searchBean?.zoneId,
            //@ts-ignore
            cityId: obj.place.cityID || searchBeanStore.searchBean.cityID,
            provinceId: obj.place.provinceID,
            regionId: obj.place.regionID,
            cityDisplayName: obj.place.cityName,
            cityURL: obj.place.cityURL,
            zoneURL: obj.searchBean?.zoneURL,
            districtURL: obj.searchBean?.districtURL,
            districtId: obj.searchBean?.districtId,
            districtIdList: obj.searchBean?.districtIdList
        });
    }
    const updateSearchBeanByMapPlace = (mapPlace: { polygon: string; polygonForDB: string; }): void => {
        searchBeanStore.updateSearchBean({
            areaOfInterestId: undefined,
            polygonFromMap: mapPlace.polygon,
            polygonForDB: mapPlace.polygonForDB,
            areaId: undefined,
            placeType: undefined,
            placeId: undefined,
            zoneId: undefined,
            zoneIdList: [],
            localityIdList: [],
            cityId: undefined,
            provinceId: undefined,
            regionId: undefined,
            cityDisplayName: undefined,
            cityURL: undefined,
            zoneURL: undefined,
            streetURL: undefined,
        });
    }
    const updateCounter = (): void => {
        if (searchBeanStore.searchBean.contractType && (searchBeanStore.searchBean.placeId || searchBeanStore.searchBean.polygonFromMap)) {
            searchBeanStore.updateSearchBean(searchBeanStore.searchBean);
        }
    }


    return {
        updateSearchBeanBySearchPlace,
        updateSearchBeanByMapPlace,
        updateCounter
    }

}